(function(root){
  'use strict';
  function rank(films, answers) {
    if (!['35mm','120'].includes(answers.format)) return [];
    return films.filter(f => f.format === answers.format && f.available === true).map((film,index) => {
      let score = 0;
      const iso = Number(film.iso);
      if (answers.light === 'sun' && iso >= 50 && iso <= 200) score += 6;
      if (answers.light === 'inside' && iso >= 800) score += 6;
      if (answers.light === 'cloud' && iso >= 400 && iso <= 800) score += 6;
      if (answers.light === 'travel' && iso >= 200 && iso <= 400) score += 6;
      if (['inside','travel'].includes(answers.light) && film.forgiving) score += 2;
      if (answers.look === 'bw' ? film.look === 'bw' : film.look !== 'bw') score += 8;
      if (answers.look === film.look) score += 6;
      return {...film,score,index};
    }).sort((a,b) => b.score-a.score || a.index-b.index);
  }
  if(typeof module !== 'undefined') module.exports={rank};
  root.AnalogueFilmFinder={rank};
})(typeof window !== 'undefined' ? window : globalThis);
